import { render } from "./OParafii.vue?vue&type=template&id=0428323a"
import script from "./OParafii.vue?vue&type=script&lang=js"
export * from "./OParafii.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__